import { REMOVE_REASONS_LIST, REMOVE_REASONS_LIST_NOFIRM, MAX_LEN, REMOVE_MIN_COUNT, REMOVE_REFUSE_REASON_ID } from "./const";
import { node, icon } from "~/util/dom";
import { isFirmFromReview, getFirmLayout, createDeleteInfo } from "~/util/review";
import { deleteReview } from "~/util/providers/review";
import { IReview, IReviewItem } from "./interfaces";
import { IReviewConf } from "~/interfaces";
import { _ } from "~/i18n";


interface IFirmReviewRemove {
	data: IReviewConf;
	myReview?: IReviewItem;
	logSource?: string;
	analytics?: object;
	logPosition?: string;
	onDelete?: null | (() => void);
	onClose?: null | (() => void);
	selectedReasonIndex?: number;
}

export default class FirmReviewRemove {
	_opts: IFirmReviewRemove;

	_dom: {
		[key: string]: null | HTMLElement;
		text?: HTMLTextAreaElement;
	};

	_isOtherChecked: boolean;

	_isFirm: boolean;

	_isRefuse: boolean;

	constructor(optsArg: IFirmReviewRemove) {
		const opts = {
			data: null,
			myReview: null,
			logSource: "",
			analytics: {},
			logPosition: "",
			onDelete: null,
			onClose: null,
			selectedReasonIndex: 0,
			...optsArg,
		};

		this._opts = opts;
		this._dom = {
			container: node("div", { className: "firm-review-report" }),
			cover: node("div", { className: "firm-review-report-cover" }),
		};
		this._isOtherChecked = false;
		this._isFirm = isFirmFromReview(this._opts.myReview);
		this._isRefuse = !!(this._opts.myReview?.state === "rejected");

		if (!this._isFirm) {
			this._dom.container.classList.add("no-firm-remove");
		}

		this._build();
		this._update();
		this._updateRest();
	}

	destroy() {
		document.body.removeEventListener("keydown", this);
		this._dom.cover.remove();
	}

	handleEvent(event: KeyboardEvent) {
		switch (event.type) {
			case "keydown":
				if (event.code === "Escape") {
					this.close();
					this._opts.onClose && this._opts.onClose();
				}
				break;

			default:
				break;
		}
	}

	close(noAnalytics?: boolean) {
		if (!noAnalytics) {
			// analytika pro mapy
			this._log("reviews_deleteForm_close");
		}

		this.destroy();
	}

	_build() {
		const title = node("h2", { textContent: this._isFirm && !this._isRefuse ? _("detail.content.review2.remove.title") : _("detail.content.review2.remove.titleNoFirm") });
		const reasons = node("div", { className: "reasons" });
		const closeSvg = icon("close");

		closeSvg.addEventListener("click", () => {
			this.close();
			this._opts.onClose && this._opts.onClose();
		});
		closeSvg.tabIndex = 0;

		this._dom.container.appendChild(closeSvg);
		this._dom.container.appendChild(title);
		this._dom.container.appendChild(reasons);

		const reasonsList = this._isFirm && !this._isRefuse ? REMOVE_REASONS_LIST : REMOVE_REASONS_LIST_NOFIRM;

		reasonsList.forEach((item, ind) => {
			const label = node("label", { className: "radiocheck" });
			const input = node("input", { type: "radio", name: "reportReason", value: item.id.toString() });

			if (ind === this._opts.selectedReasonIndex) {
				input.checked = true;
			}

			input.addEventListener("change", () => {
				this._isOtherChecked = item.fillText && input.checked;

				this._update();
			});

			const span = node("span", { textContent: _(item.transText) });

			label.appendChild(input);
			label.appendChild(span);
			reasons.appendChild(label);
		});

		const otherTitle = node("h3", { textContent: _("badPhoto.note") });
		const text = node("textarea", { placeholder: _("detail.content.review2.reportPlaceholder") });

		text.setAttribute("maxlength", MAX_LEN.toString());

		text.addEventListener("input", () => {
			this._update();
			this._updateRest();
		});

		const counter = node("p", { className: "counter" });
		const error = node("p", { className: "error" });
		const placeholder = node("div", { className: "placeholder" });
		const buttons = node("div", { className: "buttons" });
		const sendBtn = node("button", { className: "send-btn", textContent: this._isFirm && !this._isRefuse ?_("detail.content.review2.removeReview") : _("delete") });

		sendBtn.setAttribute("data-log-ignore", "");
		sendBtn.appendChild(node("span", { className: "bubble", textContent: _("detail.content.review2.remove.minCountBubble") }));
		sendBtn.addEventListener("click", () => {
			// analytika pro mapy
			this._log("click", {
				text: "deleteReview",
			});
			this._send();
		});

		const cancelBtn = node("button", { className: "cancel-btn", textContent: _("cancel") });

		cancelBtn.setAttribute("data-log-ignore", "");
		cancelBtn.addEventListener("click", () => {
			this.close();
			this._opts.onClose && this._opts.onClose();
		});

		buttons.appendChild(sendBtn);
		buttons.appendChild(cancelBtn);

		if (this._isFirm && !this._isRefuse) {
			this._dom.container.appendChild(otherTitle);
			this._dom.container.appendChild(text);
			this._dom.container.appendChild(counter);
		}

		this._dom.container.appendChild(buttons);
		this._dom.container.appendChild(error);
		this._dom.container.appendChild(placeholder);

		Object.assign(this._dom, { text, error, counter, sendBtn, buttons });

		this._dom.cover.append(this._dom.container);
		document.body.appendChild(this._dom.cover);
		document.body.addEventListener("keydown", this);
		closeSvg.focus();
	}

	_send() {
		const data = this._isFirm && !this._isRefuse
			? this._getData()
			: {
				reasonId: this._isRefuse ? REMOVE_REFUSE_REASON_ID : 0,
				type: this._isRefuse ? REMOVE_REFUSE_REASON_ID : 1,
			};
		const text = this._isFirm ? this._dom.text.value.trim() : "";

		this._dom.error.innerHTML = "";

		// analytika pro mapy
		this._log("delete_my_review", {
			// ma recenze text
			text: this._opts.myReview?.text === "" ? 0 : 1,
			...this._isFirm
				? {
					type: data.type,
				}
				: {},
		});

		const loader = node("div", { className: "overlay-loader" });
		const imgLoader = node("img", { src: "/img/loader.gif", className: "img-loader" });

		this._dom.container.appendChild(loader);
		this._dom.buttons.insertBefore(imgLoader, this._dom.buttons.firstChild);

		const removeCb = () => {
			loader.remove();
			imgLoader.remove();
		};

		// reasonId muze byt string|number
		deleteReview({
			reviewId: this._opts.myReview.id,
			reason: data.reasonId,
			text,
		}).then(updatedReview => {
			removeCb();
			this._opts.onDelete && this._opts.onDelete();
			this._createCloseDialog(updatedReview);
		}, error => {
			// eslint-disable-next-line no-console
			console.error(error);
			removeCb();
			this._dom.error.innerHTML = _("detail.content.review2.remove.saveError");
		});
	}

	_getData() {
		const elem: HTMLInputElement = this._dom.container.querySelector("input:checked");
		const type = parseFloat(elem.value);
		const selReasonList = REMOVE_REASONS_LIST.filter(item => item.id === type);
		const selReason = selReasonList.length ? selReasonList[0] : REMOVE_REASONS_LIST[0];

		return {
			reasonId: selReason.id,
			fillText: selReason.fillText,
			type: type,
		};
	}

	_createCloseDialog(updatedReview: Partial<IReview>) {
		this.close(true);
		createDeleteInfo();

		// aktualizace vypisu
		const reviewsList = Mapy.getComponent("reviewslist");
		const review = {
			...JSON.parse(JSON.stringify(this._opts.data.review)),
			...Object.keys(updatedReview).length > 0
				? updatedReview
				: {
					total: this._opts.data.review.total - 1,
				},
		};

		if (reviewsList.isActive()) {
			reviewsList.removeMyReview(review);
		}

		// zavolame callback pro comments a review
		const logObj = {
			detail: {
				rusAdmin: false,
				review: review,
				myReview: null,
			},
		};

		window.dispatchEvent(new CustomEvent("firmreview-review-myreview", logObj));
		window.dispatchEvent(new CustomEvent("firmreview-comments-myreview", logObj));
	}

	_update() {
		const count = this._dom.text.value.length;

		this._dom.sendBtn.removeAttribute("disabled");

		// omezeni textarey
		if ((count >= 1 && count <= REMOVE_MIN_COUNT - 1) || (this._isOtherChecked && count < REMOVE_MIN_COUNT)) {
			this._dom.sendBtn.setAttribute("disabled", "true");
		}
	}

	_updateRest() {
		const chars = MAX_LEN - this._dom.text.value.length;

		this._dom.counter.innerHTML = `${_("detail.content.review.numOfChar", {
			chars,
		})} `;
		const minCount = node("span", { className: "min-count" });

		minCount.textContent = `(${_("detail.content.review2.remove.minCount")})`;
		this._dom.counter.appendChild(minCount);
	}

	_log(name: string, data?: object) {
		/* eslint-disable camelcase */
		Mapy.getComponent("logger").log(name, {
			position: this._opts.logPosition,
			// eslint-disable-next-line camelcase
			rating_layout: getFirmLayout(this._opts.data.review, this._opts.data.booking, this._opts.myReview, this._opts.data.isFirm),
			refused: this._opts.myReview?.state === "rejected" ? 1 : 0,
			source: this._opts.logSource,
			sourcePoi: this._opts.data.source,
			typeid: this._opts.data.typeId,
			firmTwin: this._opts.data.isTwin ? 1 : 0,
			section: "reviews",
			...this._opts.analytics,
			...data,
		});
	}
}
